import React from 'react';
import InterventionGroupManager from '../components/InterventionGroupManager';

const InterventionGroupsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <InterventionGroupManager />
    </div>
  );
};

export default InterventionGroupsPage;

